"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnchorLink", {
  enumerable: true,
  get: function get() {
    return _AnchorLink.AnchorLink;
  }
});

var _AnchorLink = require("./components/AnchorLink");